var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50886 13.2066C4.50886 14.4182 3.52957 15.3975 2.31791 15.3975C1.10624 15.3975 0.126953 14.4182 0.126953 13.2066C0.126953 11.9949 1.10624 11.0156 2.31791 11.0156H4.50886V13.2066Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60352 13.2066C5.60352 11.9949 6.58281 11.0156 7.79447 11.0156C9.00613 11.0156 9.98542 11.9949 9.98542 13.2066V18.684C9.98542 19.8956 9.00613 20.8749 7.79447 20.8749C6.58281 20.8749 5.60352 19.8956 5.60352 18.684V13.2066Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79447 4.41023C6.58281 4.41023 5.60352 3.43094 5.60352 2.21928C5.60352 1.00761 6.58281 0.0283203 7.79447 0.0283203C9.00613 0.0283203 9.98542 1.00761 9.98542 2.21928V4.41023H7.79447Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79432 5.52197C9.00598 5.52197 9.98527 6.50126 9.98527 7.71293C9.98527 8.92459 9.00598 9.90388 7.79432 9.90388H2.30033C1.08867 9.90388 0.109375 8.92459 0.109375 7.71293C0.109375 6.50126 1.08867 5.52197 2.30033 5.52197H7.79432Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5762 7.71293C16.5762 6.50126 17.5555 5.52197 18.7671 5.52197C19.9788 5.52197 20.9581 6.50126 20.9581 7.71293C20.9581 8.92459 19.9788 9.90388 18.7671 9.90388H16.5762V7.71293Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4796 7.71326C15.4796 8.92493 14.5003 9.90422 13.2886 9.90422C12.0769 9.90422 11.0977 8.92493 11.0977 7.71326V2.21928C11.0977 1.00761 12.0769 0.0283203 13.2886 0.0283203C14.5003 0.0283203 15.4796 1.00761 15.4796 2.21928V7.71326Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2886 16.4932C14.5003 16.4932 15.4796 17.4725 15.4796 18.6841C15.4796 19.8958 14.5003 20.8751 13.2886 20.8751C12.0769 20.8751 11.0977 19.8958 11.0977 18.6841V16.4932H13.2886Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2886 15.398C12.0769 15.398 11.0977 14.4187 11.0977 13.2071C11.0977 11.9954 12.0769 11.0161 13.2886 11.0161H18.7826C19.9943 11.0161 20.9736 11.9954 20.9736 13.2071C20.9736 14.4187 19.9943 15.398 18.7826 15.398H13.2886Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.18f3ec78.svg";
export { ForwardRef as ReactComponent };